import type { Asset, Stored } from "@overmap-ai/common"
import { Mention } from "@tiptap/extension-mention"
import { mergeAttributes, ReactNodeViewRenderer } from "@tiptap/react"

import type { MentionOptions } from "../typings"
import { AssetMentionComponent } from "./Component"
import { suggestion } from "./suggestion"

export const AssetMention = Mention.extend<MentionOptions<Stored<Asset>>>({
	name: "AssetMention",
	atom: true,
	addAttributes() {
		return {
			uuid: {
				default: null,
			},
		}
	},
	parseHTML() {
		return [
			{
				tag: "asset-mention",
			},
		]
	},
	renderHTML({ HTMLAttributes }) {
		return ["asset-mention", mergeAttributes(HTMLAttributes)]
	},
	addNodeView() {
		return ReactNodeViewRenderer(AssetMentionComponent)
	},
}).configure({
	suggestion,
})
